// Audited against the original art, square wiki portraits, 90px game circles and 24px thumbnails.
// Portrait: scale, horizontal/vertical focus (%). Circle: width (%), horizontal/vertical focus (%).
type Framing = readonly [number, number, number, number, number, number];

export const roleFraming: Record<'default' | 'legacy' | 'anime', Record<string, Framing>> = {
  default: {
    merlin: [1.1, 45, 0, 160, 45, 0],
    merlin_pure: [1.1, 55, 0, 160, 55, 0],
    guinevere: [1.25, 42, 0, 135, 42, 15],
    percival: [1.3, 50, 0, 170, 50, 15],
    tristan: [1.3, 40, 0, 145, 40, 5],
    isolde: [1.5, 53, 0, 165, 53, 0],
    cleric: [1.25, 60, 0, 125, 60, 10],
    troublemaker: [1.2, 53, 0, 165, 53, 0],
    servant: [1.25, 48, 5, 150, 48, 5],
    good_lancelot: [1.25, 48, 0, 140, 48, 0],
    evil_lancelot: [1.25, 48, 0, 140, 48, 0],
    unknown_lancelot: [1.25, 48, 0, 140, 48, 0],
    mordred: [1.3, 45, 0, 170, 45, 0],
    morgana: [1.3, 51, 0, 165, 51, 20],
    oberon: [1.3, 55, 10, 200, 60, 20],
    wraith: [1.3, 55, 10, 200, 60, 20],
    trickster: [1.1, 52, 0, 165, 52, 23],
    witch: [1, 50, 0, 120, 45, 5],
    revealer: [1.1, 43, 10, 130, 43, 35],
    revealer_hidden: [1.1, 43, 10, 130, 43, 35],
    revealer_progress: [1.1, 43, 10, 130, 43, 35],
    lunatic: [1.2, 52, 0, 140, 52, 15],
    brute: [1.25, 51, 0, 145, 51, 10],
    minion: [1.1, 40, 0, 150, 40, 0],
    mystery: [1.2, 50, 0, 160, 50, 5],
  },
  legacy: {
    merlin: [1, 50, 20, 100, 50, 15],
    merlin_pure: [1, 50, 20, 100, 50, 20],
    guinevere: [1, 50, 5, 100, 50, 15],
    percival: [1, 50, 5, 105, 50, 15],
    tristan: [1, 50, 5, 100, 50, 15],
    isolde: [1, 50, 5, 100, 50, 15],
    cleric: [1, 50, 0, 100, 50, 10],
    troublemaker: [1, 50, 10, 100, 50, 20],
    servant: [1, 50, 0, 100, 50, 0],
    good_lancelot: [1, 50, 5, 100, 50, 15],
    evil_lancelot: [1, 50, 5, 100, 50, 15],
    unknown_lancelot: [1, 50, 5, 100, 50, 15],
    mordred: [1, 50, 35, 100, 50, 30],
    morgana: [1, 50, 5, 100, 50, 10],
    oberon: [1, 50, 10, 100, 50, 15],
    wraith: [1, 50, 25, 100, 50, 25],
    trickster: [1, 50, 20, 100, 50, 25],
    witch: [1, 50, 15, 100, 50, 20],
    revealer: [1, 50, 15, 100, 50, 20],
    revealer_hidden: [1, 50, 15, 100, 50, 20],
    revealer_progress: [1, 50, 15, 100, 50, 20],
    lunatic: [1, 50, 10, 100, 50, 20],
    brute: [1, 50, 0, 100, 50, 10],
    minion: [1, 50, 35, 100, 50, 40],
    mystery: [1, 50, 25, 100, 50, 30],
  },
  anime: {
    merlin: [1.1, 40, 0, 175, 40, 0],
    merlin_pure: [1.1, 33, 0, 155, 33, 0],
    guinevere: [1.15, 50, 0, 160, 50, 0],
    percival: [1.35, 50, 0, 215, 50, 0],
    tristan: [1.25, 50, 0, 210, 50, 5],
    isolde: [1.25, 41, 0, 160, 41, 0],
    cleric: [1.45, 50, 0, 220, 50, 0],
    troublemaker: [1.15, 70, 0, 230, 43, 0],
    servant: [1.3, 45, 0, 180, 45, 0],
    good_lancelot: [1.15, 45, 0, 150, 45, 0],
    evil_lancelot: [1.2, 52, 0, 150, 52, 0],
    unknown_lancelot: [1.15, 45, 0, 150, 45, 0],
    mordred: [1.4, 50, 0, 220, 50, 0],
    morgana: [1.15, 50, 0, 140, 50, 0],
    oberon: [1.15, 55, 5, 170, 58, 24],
    wraith: [1.15, 55, 5, 170, 58, 24],
    trickster: [1.05, 56, 0, 180, 56, 10],
    witch: [1, 55, 0, 130, 55, 0],
    revealer: [1.1, 50, 0, 120, 50, 0],
    revealer_hidden: [1.1, 50, 0, 120, 50, 0],
    revealer_progress: [1.1, 50, 0, 120, 50, 0],
    lunatic: [1.15, 55, 0, 145, 55, 5],
    brute: [1.3, 48, 0, 175, 48, 0],
    minion: [1.2, 43, 0, 190, 43, 0],
    mystery: [1.3, 50, 0, 190, 50, 8],
  },
};
